import { useState } from "react";
import PropTypes from "prop-types";
import { Modal, Button, Input } from "common-components";
import { UiModalTitle, StyledUpdateRemark } from "./UpdateRemarkModal.style";

export const UpdateRemarkModal = ({ reports, isLoading, onOk, onCancel }) => {
	const isBatch = reports.length > 1;
	const [remark, setRemark] = useState(isBatch ? "" : reports[0]?.remark || "");

	return (
		<Modal
			title={<UiModalTitle>修改備註留言</UiModalTitle>}
			visible={true}
			width="480px"
			onCancel={onCancel}
			footer={
				<>
					<Button variant="white" full={false} onClick={onCancel}>
						取消
					</Button>
					<Button variant="orange" full={false} loading={isLoading} onClick={() => onOk(remark)}>
						送出
					</Button>
				</>
			}>
			<StyledUpdateRemark>
				{isBatch && (
					<div className="hint">
						已勾選 <span>{reports.length}</span> 筆，送出後將覆蓋所有勾選回報的備註留言
					</div>
				)}
				<Input.TextArea placeholder="請輸入備註留言" value={remark} onChange={(e) => setRemark(e.target.value)} />
			</StyledUpdateRemark>
		</Modal>
	);
};

UpdateRemarkModal.propTypes = {
	reports: PropTypes.array,
	isLoading: PropTypes.bool,
	onOk: PropTypes.func,
	onCancel: PropTypes.func,
};
